import { useContext } from 'react';
import { GlobalDataContext } from './globalDataProvider'

const useGlobalData = () => {
  return useContext(GlobalDataContext);
};

export default useGlobalData;
